// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CachingConfigurationAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { isEmpty } from 'lodash/fp';
export default withHandlers({
  onChangeDataCacheSetting: ({ store: { cachingConfiguration } }) => (dataKey, value) => {
    cachingConfiguration.setDataCachingValueByKey(dataKey, value);
  },

  onChangeSystemCacheSetting: ({ store: { cachingConfiguration } }) => (dataKey, value) => {
    cachingConfiguration.setSystemCachingValueByKey(dataKey, value);
  },

  /**
   * Cancel Change config
   */
  cancelChangeConfig: props => () => {
    const { validation: valManager, localization, store } = props;
    const { cachingConfiguration, alertDetails } = store;
    resetAlert(props);
    if (!cachingConfiguration.isDirty) {
      setAlertDetails(alertDetails, null, localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
    } else {
      return props
        .confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
        })
        .then(() => {
          valManager.reset();
          store.loadCachingConfiguration.apply(store);
        });
    }
  },

  /**
   * Save Caching config
   */
  saveConfig: props => () => {
    const { validation: valManager, localization, store, loader } = props;
    const { cachingConfiguration, alertDetails } = store;
    resetAlert(props);
    if (!cachingConfiguration.isDirty) {
      setAlertDetails(alertDetails, null, localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
    } else {
      valManager.validate().then(success => {
        if (success) {
          return props
            .confirmFn('Confirmation', {
              description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
            })
            .then(() => {
              loader.startLoading();
              return store.saveCachingConfiguration();
            })
            .then(result => {
              const messages = result.messages || {};
              isEmpty(messages)
                ? setAlertDetails(alertDetails, true, localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'))
                : updateErrors(valManager, messages);
            })
            .finally(loader.endLoading.bind(loader));
        }
      });
    }
  },

  /**
   * Reset alert details
   */
  resetAlert: props => () => resetAlert(props)
});
const resetAlert = props => {
  return props.store.alertDetails.reset();
};
const setAlertDetails = (alertDetails: any, success: any, message: string) => {
  alertDetails.set({
    success: success,
    message: message
  });
};

const updateErrors = (valManager: any, messages) => {
  valManager.updateErrors(messages);
};



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Caching/Izenda.CachingConfigurationAction.js